import { render, staticRenderFns } from "./InstantFormProcessEnd.vue?vue&type=template&id=6ba86586&scoped=true&"
import script from "./InstantFormProcessEnd.vue?vue&type=script&lang=ts&"
export * from "./InstantFormProcessEnd.vue?vue&type=script&lang=ts&"
import style0 from "./InstantFormProcessEnd.vue?vue&type=style&index=0&id=6ba86586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba86586",
  null
  
)

export default component.exports